<script>
import formStepMixin from '@phoenix/mixins/formStepMixin';
import FormGroup from '@maison/components/form/FormGroup.vue';
import NewsletterField from '@maison/components/form/fields/NewsletterField.vue';

export default {
  components: {
    FormGroup,
    NewsletterField,
  },

  mixins: [formStepMixin],

  inject: ['isStepEnabled'],

  props: {
    privacyLink: {
      type: String,
      default: '',
    },
    steps: {
      type: Array,
      required: true,
    },
  },

  emits: ['changeStep'],

  computed: {
    enabledSteps() {
      return this.steps.filter((step) => this.isStepEnabled(step.step));
    },
  },

  methods: {
    changeStep(step) {
      this.$emit('changeStep', { step, scrollToNavigation: false });
    },

    getFieldValue(field) {
      field = this.fields[field];
      if (!field) {
        return '';
      }

      if (Object.hasOwn(field, 'options')) {
        const option = field.options.find((option) => option.value === field.value);
        if (option) {
          return option.label;
        }
      }

      return field.value;
    },
  },
};
</script>

<template>
  <div>
    <legend class="sr-only">{{ $t(`Form.gep.step4.label`) }}</legend>

    <h5 class="mb-8">{{ $t(`Form.gep.step4.title`) }}</h5>

    <div class="flex-grid flex-grid--y--md">
      <div
        v-for="step in enabledSteps"
        :key="`step-recap-${step.step}`"
        class="w-full bg-gray-100 border-l-4 border-gray-200 mt-5 p-5"
      >
        <h6 class="mb-2">{{ $t(`Form.gep.step${step.step}.label`) }}</h6>

        <template v-for="field in step.attrs.stepFields">
          <p v-if="getFieldValue(field)" :key="`step-recap-field-${field}`">
            <span class="font-bold">{{ fields[field].label }}: </span>
            <span>{{ getFieldValue(field) }}</span>
          </p>
        </template>

        <div class="sgphx">
          <button
            class="sgphx-btn sgphx-btn--underline"
            :data-cy="`form-edit-step-${step.step}`"
            @click.prevent.stop="changeStep(step.step)"
          >
            <span class="sgphx-btn__text">
              <span>{{ $t('Form.edit') }}</span>
            </span>
          </button>
        </div>
      </div>

      <div class="w-full">
        <form-group :show-label="false" :attrs="fields.newsletter">
          <newsletter-field v-model="fields.newsletter.value" :privacy-link="privacyLink" use-stay-in-touch-as-label />
        </form-group>
      </div>
    </div>
  </div>
</template>
